import { useLocation } from "react-router-dom";
import dayjs from 'dayjs';
import uploadFileToS3, { uploadFilesToS3 } from "./awsS3Functions";
// import uploadChatFileToS3 from "./awsS3ChatFunctions";
import { saveAs } from 'file-saver';
import { ShowToast } from "../components/show-toast/ShowToast";
import { getStoredUser } from "../utils/storage";
import constData, { fillipinoId, indonesiaId } from "../components/ReusableComponents/constants";
import { HOST_TYPE, REACT_APP_X_API_KEY } from "./apiPath";

let permissionInfo = {
    'worker_chat': [],
    'worker_contact_details': [],
    'worker_remarks': [],
    'worker_action_require_history': [],
    'worker_chat_history': [],
    'worker_status_to_hold': [],
    'worker_status_to_suspended': [],
    'worker_status_to_ban': [],
    'worker_employer_chat': [],
    'worker_jo_share': [],
    'worker_jo_share_link': [],
    'worker_interview_decline': [],
    'worker_interview_accept': [],
    'worker_interview_reschedule': [],
    'worker_interview_report': [],
    'worker_worker_profile': [],
    'worker_worker_biodata': [],
    'worker_worker_photo': [],
    'worker_philippines_worker_doc_upload': [],
    'worker_philippines_worker_assign_partner': [],
    'worker_indonesia_worker_doc_upload': [],
    'worker_indonesia_worker_assign_partner': [],
    'worker_indonesia_worker_assign_pt': [],
    'worker_worker_details': [],
    'worker_worker_basic_details': [],
    'worker_worker_consulate_details': [],
    'worker_worker_passport_details': [],
    'worker_worker_activity': [],
};

const dayMapping = {
    1: "Sunday",
    2: "Monday",
    3: "Tuesday",
    4: "Wednesday",
    5: "Thursday",
    6: "Friday",
    7: "Saturday"
};

const getAccessToken = () => {
    const currentUser = getStoredUser();
    if (currentUser && currentUser.token) {
        return currentUser.token;
    }
    return null;
}

const getCurrentUser = () => {
    const currentUser = getStoredUser();
    if (currentUser) {
        return currentUser;
    }
    return null;
}

const isBangladeshOrThailandPartner = () => {
    const staffCountryId = getCurrentUser()?.data?.staff?.staff_country_id;
    return (staffCountryId === constData.PARTNER_BANGLADESH_COUNTRY_ID) || (staffCountryId === constData.PARTNER_THAILAND_COUNTRY_ID)
}

const relationMap = {
    1: 'Father',
    2: 'Mother',
    3: 'Brother',
    4: 'Sister',
    5: 'Son',
    6: 'Daughter'
};

const getCalculatedAge = (dobFormat, yearOnly) => {
    if (!dobFormat) {
        return null;
    }

    if (yearOnly === 'y') {
        const birthYear = dayjs(dobFormat, 'YYYY').year();
        const currentYear = dayjs().year();
        return currentYear - birthYear;
    } else {
        const birthDate = dayjs(dobFormat, 'YYYY-MM-DD');
        if (!birthDate.isValid()) {
            return null;
        }
        return dayjs().diff(birthDate, 'years');
    }
};

const extractIds = (options) => options?.filter(e => e?.id != null).map(e => e.id) || [];

const convertToYesNo = (value) => (value === 1 ? "yes" : "no");

const convertToNumeric = (value) => (value === "yes" ? 1 : 0);

const formatDateTime = (date) => dayjs(new Date(date)).format("YYYY-MM-DD HH:mm:ss");

const getCurrentDate = () => dayjs(new Date()).format("YYYY-MM-DD");

const formatDate = (date) => dayjs(new Date(date)).format("YYYY-MM-DD");

const formatTime = (date, format = 'HH:mm:ss') => {
    return dayjs(new Date(date)).format(format);
};

const convertToDayType = (value) => (value === "first_half" ? "key_first_half" : "key_second_half");

const leaveDisplayStatus = (value) => (value === 0 ? "Pending" : (value === 1 ? "Approved" : (value === 2 ? "Rejected" : "Withdrawn")));

const getLeaveButtonClass = (leaveType) => {
    switch (leaveType) {
        case 'Casual Leaves':
            return 'casual';
        case 'Sick Leaves':
            return 'sick';
        case 'Paid Leaves':
            return 'leave';
        case 'Birthday Leaves':
            return 'birthday';
        case 'Priviledged Leaves':
            return 'priviledged';
        case 'Extra Leaves':
            return 'extra';
        default:
            return 'casual';
    }
};

const getLocalTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const calculateDuration = (start_date, start_date_type, end_date, end_date_type) => {
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);
    let durationInMs = endDate - startDate;
    if (startDate.toDateString() === endDate.toDateString() && start_date_type !== end_date_type) {
        return 1;
    } else if (startDate.toDateString() === endDate.toDateString() && start_date_type === start_date_type) {
        return 0.5;
    }
    if (start_date_type === 'first_half' && end_date_type === 'second_half') {
        durationInMs += (24 * 60 * 60 * 1000);
    } else if ((start_date_type === 'first_half' && end_date_type === 'first_half') || (start_date_type === 'second_half' && end_date_type === 'second_half')) {
        durationInMs += (12 * 60 * 60 * 1000);
    }
    const durationInDays = durationInMs / (1000 * 60 * 60 * 24);
    return durationInDays;
};

const useQuery = () => new URLSearchParams(useLocation().search);

const doopDays = (doop_names) => {
    return doop_names.split(',').map(num => dayMapping[num.trim()]).join(', ')
}

const shortenText = (text, length = 20) => {
    return text.length > length ? `${text.substring(0, length)}...` : text;
}

const uploadFile = async (filesToUpload) => {
    let image = {};
    for (const file of filesToUpload) {
        await uploadFileToS3(file.file, file.name, true)
            .then((path) => {
                image = path;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    return image;
}

const uploadFiles = async (filesToUpload) => {

    let response = {};
    // for (const file of filesToUpload) {
    await uploadFilesToS3(filesToUpload)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
        });
    // }
    return response;
}

export const handleMobileInput = (e) => {
    let value = e.target.value;

    value = value.replace(/\D/g, "");

    if (value.length > 13) {
        value = value.slice(0, 13);
    }

    e.target.value = value;
};

export const handleFaxNumberInput = (e) => {
    let value = e.target.value;

    // Allow digits, plus sign, spaces, parentheses, dashes, and dots
    // Remove everything except digits and plus sign
    value = value.replace(/[^\d+]/g, "");

    // Ensure plus sign is only at the beginning
    const hasPlus = value.startsWith('+');
    const digitsOnly = value.replace(/\+/g, '');

    // If plus was in the middle, remove it
    let formattedValue = hasPlus ? '+' + digitsOnly : digitsOnly;

    // Enforce maximum length (15 for E.164 standard + 1 for plus sign = 16)
    if (formattedValue.length > 16) {
        formattedValue = formattedValue.slice(0, 16);
    }

    // Prevent multiple plus signs
    if (formattedValue.split('+').length > 2) {
        formattedValue = '+' + formattedValue.replace(/\+/g, '');
    }

    e.target.value = formattedValue;
};

export const sanitizeAndLimitHKID = (value) => {
    if (!value) return "";

    const upper = value.toUpperCase();

    // Remove non-alphanumeric except ()
    const cleaned = upper.replace(/[^A-Z0-9()]/g, '');

    // Remove parentheses for length check
    const raw = cleaned.replace(/[()]/g, '');

    const maxLength = raw[1] === 'X' ? 9 : 8;

    // Block extra characters
    if (raw.length > maxLength) return null;

    return cleaned;
};

const showSuccessOrError = (response) => {
    const { error, payload } = response;
    if (error) {
        const errorMessage = payload?.message ? payload?.message : (payload?.data && payload?.data?.data && payload?.data?.data?.message) ? payload?.data?.data?.message : 'An unexpected error occurred.';
        ShowToast('error', errorMessage);
    } else {
        if (!payload.status) {
            const errorMessage = payload?.message;
            ShowToast('error', errorMessage);
        } else {
            const successMessage = payload?.message || 'Operation completed successfully.';
            ShowToast('success', successMessage);
        }
    }
};

const showErrorMessage = (response) => {
    const { error, payload } = response;
    if (error) {
        const errorMessage = payload?.message ? payload?.message : (payload?.data && payload?.data?.data && payload?.data?.data?.message) ? payload?.data?.data?.message : 'An unexpected error occurred.';
        ShowToast('error', errorMessage);
    }
};


const uploadChatFile = async (filesToUpload) => {
    let image = {};
    for (const file of filesToUpload) {
        await uploadFileToS3(file.file, file.name, true)
            .then((path) => {
                image = path;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    return image;
}

const getTimeRequestStatusLabel = (status) => {
    switch (status) {
        case 0:
            return { label: 'Pending', className: 'chip pending' };
        case 1:
            return { label: 'Partially Approved', className: 'chip approved' };
        case 2:
            return { label: 'Approved', className: 'chip approved' };
        case 3:
            return { label: 'Rejected', className: 'chip rejected' };
        case 4:
            return { label: 'Withdrawn', className: 'chip withdrawn' };
        default:
            return { label: 'Unknown', className: 'chip unknown' };
    }
};

const ledgerDisplayType = (type) => {
    return type == "minus" ? "Debit" : "Credit";
};

const arrayToObjectCovert = (array) => {
    const object = array.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
    }, {});
    return object;
};

const getContractInvoiceStatusLabel = (status) => {
    switch (status) {
        case 1:
            return { label: 'Unsettled', className: 'btn btn-info' }; //not paid
        case 2:
            return { label: 'Partially Paid', className: 'btn btn-warning' };
        case 4:
            return { label: 'Paid', className: 'btn btn-success' };
        case 5:
            return { label: 'Refunded', className: 'btn btn-info' };
        default:
            return { label: 'Unknown', className: 'btn-info' };
    }
};

const invoicesStatusFilterOptions = () => {
    return [
        { id: 1, name: 'Unsettled' },
        { id: 2, name: 'Partially Paid' },
        { id: 3, name: 'Awaiting Approval' },
        { id: 4, name: 'Paid' },
        { id: 5, name: 'Refunded' },
        { id: 6, name: 'Voided' },
    ]
};

const mapFamilyDetailsInfo = (currentEmployer) => [
    { needsCare: "Adults", name: "adult_count", count: currentEmployer.adult_count },
    { needsCare: "Age 5 to 18", name: "child_age_5_8_count", count: currentEmployer.child_age_5_8_count },
    { needsCare: "Age below 5", name: "child_age_below_5_count", count: currentEmployer.child_age_below_5_count },
    { needsCare: "Expecting Babies", name: "expecting_baby_count", count: currentEmployer.expecting_baby_count },
    { needsCare: "Special Needs", name: "special_needs_count", count: currentEmployer.special_needs_count }
];




const mapFamilyDetails = (currentEmployer) => [
    { needsCare: "Adults", count: currentEmployer.adult_count, details: currentEmployer.adult_count_info },
    { needsCare: "Expecting Baby", count: currentEmployer.expecting_baby_count, details: [] },
    { needsCare: "Baby (under 1 Y/O)", count: currentEmployer.baby_count, details: currentEmployer.baby_count_info },
    { needsCare: "Child", count: currentEmployer.child_count, details: currentEmployer.child_count_info },
    { needsCare: "Elderly", count: currentEmployer.elderly_count, details: currentEmployer.elderly_count_info }
];

const getDisplayAgencyType = (type) => {
    switch (type) {
        case 'internal':
            return 'Internal';
        case 'external':
            return 'External';
        default:
            return 'Internal';
    }
};

const getDisplayAgencyCategory = (category) => {
    switch (category) {
        case 'host':
            return 'Host';
        case 'partner':
            return 'Partner';
        default:
            return 'Host';
    }
};

const downloadExcelFromBufferData = async (response, filename) => {
    try {
        const fileBlob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(fileBlob, filename);
    } catch (error) {
        console.error('Error downloading the file:', error);
    }
};

const generateFilename = (keyword, extension) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const dateTimeString = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
    const filename = `${keyword}_${dateTimeString}.${extension}`;
    return filename;
}

const downloadFile = (filePath) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const timeSince = (date) => {
    if (!date) return '';

    if (date instanceof Date) {
        return customFromNow(date);
    }

    if (typeof date === 'number') {
        return customFromNow(date);
    }

    if (typeof date === 'string') {
        if (date.endsWith('Z') || date.includes('T')) {
            return customFromNow(dayjs.utc(date));
        } else {
            return customFromNow(dayjs(date, 'YYYY-MM-DD HH:mm:ss', true));
        }
    }

    return '';
};
const getDisplayName = (str) => {
    return str
        .split('_')           // Split the string by underscores
        .map(word =>           // Capitalize the first letter of each word
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');
};

const isDisabledCsOption = (e, permission) => {
    const currentStaffId = getCurrentUser()?.data.staff?.id;
    if (isAdminUser() || permission === 'all') {
        return false;
    } else if (permission === 'owner' && e.id === currentStaffId) {
        return false;
    }
    return true;
}

const getPredefinedRangeFromDates = (start, end) => {
    const diffDays = dayjs(end).diff(dayjs(start), 'days');
    const today = dayjs().startOf('day');
    const yearStart = dayjs().startOf('year');

    if (dayjs(start).isSame(today, 'day') && dayjs(end).isSame(today, 'day')) {
        return "today";
    }
    if (dayjs(start).isSame(today.clone().subtract(1, 'day'), 'day') &&
        dayjs(end).isSame(today.clone().subtract(1, 'day'), 'day')) {
        return "yesterday";
    }
    if (diffDays === 6 && dayjs(end).isSame(today, 'day')) {
        return "last_7_days";
    }
    if (diffDays === 29 && dayjs(end).isSame(today, 'day')) {
        return "last_30_days";
    }
    if (diffDays === 59 && dayjs(end).isSame(today, 'day')) {
        return "last_60_days";
    }
    if (diffDays === 89 && dayjs(end).isSame(today, 'day')) {
        return "last_90_days";
    }
    if (dayjs(start).isSame(dayjs().startOf('month'), 'day') &&
        dayjs(end).isSame(dayjs().endOf('month'), 'day')) {
        return "this_month";
    }
    if (dayjs(start).isSame(dayjs().subtract(1, 'month').startOf('month'), 'day') &&
        dayjs(end).isSame(dayjs().subtract(1, 'month').endOf('month'), 'day')) {
        return "last_month";
    }
    if (dayjs(start).isSame(dayjs().startOf('quarter'), 'day') &&
        dayjs(end).isSame(dayjs().endOf('quarter'), 'day')) {
        return "this_quarter";
    }
    if (dayjs(start).isSame(yearStart, 'day') &&
        dayjs(end).isSame(today, 'day')) {
        return "year_to_date";
    }
    if (dayjs(start).isSame(dayjs().subtract(1, 'year').startOf('year'), 'day') &&
        dayjs(end).isSame(dayjs().subtract(1, 'year').endOf('year'), 'day')) {
        return "last_year";
    }
    return null;
};

const checkPermission = (permissions, labelKey) => {
    const user = getStoredUser();
    if (user) {
        const guardName = user?.data?.role?.guard_name;
        if (guardName !== "admin" && guardName !== "sub-admin" && permissions) {
            const flag = permissions.find((element) => {
                return labelKey == element.label_key && element.permission_value == 1;
            });
            return !!flag;
        } else {
            return true;
        }
    }
};

const formatDuration = (seconds) => {
    const d = dayjs.duration(seconds, "seconds");
    const h = Math.floor(d.asHours());
    const m = d.minutes();

    return `${ h }h ${ m }m`;
};

const getObejctByModule = (key) => {
    if (key === 'worker_interpreter_owner') {
        return {
            'worker_interpreter_owner_worker_chat': 'worker_chat',
            'worker_interpreter_owner_worker_contact_details': 'worker_contact_details',
            'worker_interpreter_owner_worker_remark': 'worker_remarks',
            'worker_interpreter_owner_action_require_history': 'worker_action_require_history',
            'worker_interpreter_owner_chat_history': 'worker_chat_history',
            'worker_interpreter_owner_change_status_to_hold': 'worker_status_to_hold',
            'worker_interpreter_owner_change_status_to_suspended': 'worker_status_to_suspended',
            'worker_interpreter_owner_change_status_to_ban': 'worker_status_to_ban',
            'worker_interpreter_owner_employer_chat': 'worker_employer_chat',
            'worker_interpreter_owner_jo_share': 'worker_jo_share',
            'worker_interpreter_owner_jo_share_link': 'worker_jo_share_link',
            'worker_interpreter_owner_interview_decline': 'worker_interview_decline',
            'worker_interpreter_owner_interview_accept': 'worker_interview_accept',
            'worker_interpreter_owner_interview_reschedule': 'worker_interview_reschedule',
            'worker_interpreter_owner_interview_report': 'worker_interview_report',
            'worker_interpreter_owner_worker_profile': 'worker_worker_profile',
            'worker_interpreter_owner_worker_biodata': 'worker_worker_biodata',
            'worker_interpreter_owner_worker_photo': 'worker_worker_photo',
            'worker_interpreter_owner_philippines_worker_doc_upload': 'worker_philippines_worker_doc_upload',
            'worker_interpreter_owner_philippines_worker_assign_partner': 'worker_philippines_worker_assign_partner',
            'worker_interpreter_owner_indonesia_worker_doc_upload': 'worker_indonesia_worker_doc_upload',
            'worker_interpreter_owner_indonesia_worker_assign_partner': 'worker_indonesia_worker_assign_partner',
            'worker_interpreter_owner_indonesia_worker_assign_pt': 'worker_indonesia_worker_assign_pt',
            'worker_interpreter_owner_worker_details': 'worker_worker_details',
            'worker_interpreter_owner_worker_basic_details': 'worker_worker_basic_details',
            'worker_interpreter_owner_worker_consulate_details': 'worker_worker_consulate_details',
            'worker_interpreter_owner_worker_passport_details': 'worker_worker_passport_details',
            'worker_interpreter_owner_worker_activity': 'worker_worker_activity',
        };
    } else if (key === 'worker_onboarding_owner') {
        return {
            'worker_onboarding_owner_worker_chat': 'worker_chat',
            'worker_onboarding_owner_worker_contact_details': 'worker_contact_details',
            'worker_onboarding_owner_worker_remark': 'worker_remarks',
            'worker_onboarding_owner_action_require_history': 'worker_action_require_history',
            'worker_onboarding_owner_chat_history': 'worker_chat_history',
            'worker_onboarding_owner_change_status_to_hold': 'worker_status_to_hold',
            'worker_onboarding_owner_change_status_to_suspended': 'worker_status_to_suspended',
            'worker_onboarding_owner_change_status_to_ban': 'worker_status_to_ban',
            'worker_onboarding_owner_employer_chat': 'worker_employer_chat',
            'worker_onboarding_owner_jo_share': 'worker_jo_share',
            'worker_onboarding_owner_jo_share_link': 'worker_jo_share_link',
            'worker_onboarding_owner_interview_decline': 'worker_interview_decline',
            'worker_onboarding_owner_interview_accept': 'worker_interview_accept',
            'worker_onboarding_owner_interview_reschedule': 'worker_interview_reschedule',
            'worker_onboarding_owner_interview_report': 'worker_interview_report',
            'worker_onboarding_owner_worker_profile': 'worker_worker_profile',
            'worker_onboarding_owner_worker_biodata': 'worker_worker_biodata',
            'worker_onboarding_owner_worker_photo': 'worker_worker_photo',
            'worker_onboarding_owner_philippines_worker_doc_upload': 'worker_philippines_worker_doc_upload',
            'worker_onboarding_owner_philippines_worker_assign_partner': 'worker_philippines_worker_assign_partner',
            'worker_onboarding_owner_indonesia_worker_doc_upload': 'worker_indonesia_worker_doc_upload',
            'worker_onboarding_owner_indonesia_worker_assign_partner': 'worker_indonesia_worker_assign_partner',
            'worker_onboarding_owner_indonesia_worker_assign_pt': 'worker_indonesia_worker_assign_pt',
            'worker_onboarding_owner_worker_details': 'worker_worker_details',
            'worker_onboarding_owner_worker_basic_details': 'worker_worker_basic_details',
            'worker_onboarding_owner_worker_consulate_details': 'worker_worker_consulate_details',
            'worker_onboarding_owner_worker_passport_details': 'worker_worker_passport_details',
            'worker_onboarding_owner_worker_activity': 'worker_worker_activity',
        };
    } else if (key === 'worker_interpreter_onboarding_non_owner') {
        return {
            'worker_interpreter_onboarding_non_owner_worker_chat': 'worker_chat',
            'worker_interpreter_onboarding_non_owner_worker_contact_details': 'worker_contact_details',
            'worker_interpreter_onboarding_non_owner_worker_remark': 'worker_remarks',
            'worker_interpreter_onboarding_non_owner_action_require_history': 'worker_action_require_history',
            'worker_interpreter_onboarding_non_owner_chat_history': 'worker_chat_history',
            'worker_interpreter_onboarding_non_owner_change_status_to_hold': 'worker_status_to_hold',
            'worker_interpreter_onboarding_non_owner_change_status_to_suspended': 'worker_status_to_suspended',
            'worker_interpreter_onboarding_non_owner_change_status_to_ban': 'worker_status_to_ban',
            'worker_interpreter_onboarding_non_owner_employer_chat': 'worker_employer_chat',
            'worker_interpreter_onboarding_non_owner_jo_share': 'worker_jo_share',
            'worker_interpreter_onboarding_non_owner_jo_share_link': 'worker_jo_share_link',
            'worker_interpreter_onboarding_non_owner_interview_decline': 'worker_interview_decline',
            'worker_interpreter_onboarding_non_owner_interview_accept': 'worker_interview_accept',
            'worker_interpreter_onboarding_non_owner_interview_reschedule': 'worker_interview_reschedule',
            'worker_interpreter_onboarding_non_owner_interview_report': 'worker_interview_report',
            'worker_interpreter_onboarding_non_owner_worker_profile': 'worker_worker_profile',
            'worker_interpreter_onboarding_non_owner_worker_biodata': 'worker_worker_biodata',
            'worker_interpreter_onboarding_non_owner_worker_photo': 'worker_worker_photo',
            'worker_interpreter_onboarding_non_owner_philippines_worker_doc_upload': 'worker_philippines_worker_doc_upload',
            'worker_interpreter_onboarding_non_owner_philippines_worker_assign_partner': 'worker_philippines_worker_assign_partner',
            'worker_interpreter_onboarding_non_owner_indonesia_worker_doc_upload': 'worker_indonesia_worker_doc_upload',
            'worker_interpreter_onboarding_non_owner_indonesia_worker_assign_partner': 'worker_indonesia_worker_assign_partner',
            'worker_interpreter_onboarding_non_owner_indonesia_worker_assign_pt': 'worker_indonesia_worker_assign_pt',
            'worker_interpreter_onboarding_non_owner_worker_details': 'worker_worker_details',
            'worker_interpreter_onboarding_non_owner_worker_basic_details': 'worker_worker_basic_details',
            'worker_interpreter_onboarding_non_owner_worker_consulate_details': 'worker_worker_consulate_details',
            'worker_interpreter_onboarding_non_owner_worker_passport_details': 'worker_worker_passport_details',
            'worker_interpreter_onboarding_non_owner_worker_activity': 'worker_worker_activity',
        };
    } else if (key === 'partner_worker') {
        return {
            'partner_worker_chat': 'worker_chat',
            'partner_worker_contact_details_view': 'worker_contact_details',
            'partner_worker_remarks': 'worker_remarks',
            'partner_worker_action_require_history': 'worker_action_require_history',
            'partner_worker_chat_history': 'worker_chat_history',
            'worker_interpreter_onboarding_non_owner_change_status_to_hold': 'worker_status_to_hold',
            'worker_interpreter_onboarding_non_owner_change_status_to_suspended': 'worker_status_to_suspended',
            'worker_interpreter_onboarding_non_owner_change_status_to_ban': 'worker_status_to_ban',
            'partner_worker_employer_chat': 'worker_employer_chat',
            'partner_worker_jo_share': 'worker_jo_share',
            'partner_worker_jo_share_link': 'worker_jo_share_link',
            'partner_worker_interview_decline': 'worker_interview_decline',
            'partner_worker_interview_accept': 'worker_interview_accept',
            'partner_worker_interview_reschedule': 'worker_interview_reschedule',
            'worker_interpreter_onboarding_non_owner_interview_report': 'worker_interview_report',
            'partner_worker_profile': 'worker_worker_profile',
            'partner_worker_biodata': 'worker_worker_biodata',
            'partner_worker_photo': 'worker_worker_photo',
            'worker_interpreter_onboarding_non_owner_philippines_worker_doc_upload': 'worker_philippines_worker_doc_upload',
            'worker_interpreter_onboarding_non_owner_philippines_worker_assign_partner': 'worker_philippines_worker_assign_partner',
            'worker_interpreter_onboarding_non_owner_indonesia_worker_doc_upload': 'worker_indonesia_worker_doc_upload',
            'worker_interpreter_onboarding_non_owner_indonesia_worker_assign_partner': 'worker_indonesia_worker_assign_partner',
            'partner_worker_indonesia_assign_pt': 'worker_indonesia_worker_assign_pt',
            'partner_worker_details_tab': 'worker_worker_details',
            'partner_worker_basic_details': 'worker_worker_basic_details',
            'partner_worker_consulate_details': 'worker_worker_consulate_details',
            'partner_worker_passport_details': 'worker_worker_passport_details',
            'partner_worker_activity': 'worker_worker_activity',
        };
    } else {
        return false;
    }
}

export const getWorkerPermissionAccess = (ownerOnboardingList, id, permissionList) => {
    if (ownerOnboardingList && permissionList) {
        if (ownerOnboardingList['interpreter_of_worker_ids'] && ownerOnboardingList['interpreter_of_worker_ids'].includes(Number(id))) {
            const module = permissionList.find(m => m.module === 'worker_interpreter_owner');
            if (module) {
                if (module.category && Array.isArray(module.category)) {
                    // Map of permissionInfo keys to category item ids
                    const permissionKeyMap = getObejctByModule('worker_interpreter_owner');
                    if (permissionKeyMap) {
                        module.category.forEach(item => {
                            let value = item.selected_value;
                            if (typeof value === 'string' && value) {
                                value = value.split(',').map(v => v.trim());
                            }
                            const key = permissionKeyMap[item.id];
                            if (key) {
                                permissionInfo[key] = value;
                            }
                        });
                    }
                }
                return permissionInfo;
            }

        } else if (ownerOnboardingList['onboarding1_of_worker_ids'] && ownerOnboardingList['onboarding1_of_worker_ids'].includes(Number(id))) {
            const module = permissionList.find(m => m.module === 'worker_onboarding_owner');
            if (module) {
                if (module.category && Array.isArray(module.category)) {
                    // Map of permissionInfo keys to category item ids
                    const permissionKeyMap = getObejctByModule('worker_onboarding_owner');
                    if (permissionKeyMap) {
                        module.category.forEach(item => {
                            let value = item.selected_value;
                            if (typeof value === 'string' && value) {
                                value = value.split(',').map(v => v.trim());
                            }
                            const key = permissionKeyMap[item.id];
                            if (key) {
                                permissionInfo[key] = value;
                            }
                        });
                    }
                }
                return permissionInfo;
            }
        } else {
            const module = permissionList.find(m => m.module === 'worker_interpreter_onboarding_non_owner');
            if (module) {
                if (module.category && Array.isArray(module.category)) {
                    // Map of permissionInfo keys to category item ids
                    const permissionKeyMap = getObejctByModule('worker_interpreter_onboarding_non_owner');
                    if (permissionKeyMap) {
                        module.category.forEach(item => {
                            let value = item.selected_value;
                            if (typeof value === 'string' && value) {
                                value = value.split(',').map(v => v.trim());
                            }
                            const key = permissionKeyMap[item.id];
                            if (key) {
                                permissionInfo[key] = value;
                            }
                        });
                    }
                }
                return permissionInfo;
            } else {
                const module = permissionList.find(m => m.module === 'partner_worker');
                if (module) {
                    if (module.category && Array.isArray(module.category)) {
                        // Map of permissionInfo keys to category item ids
                        const permissionKeyMap = getObejctByModule('partner_worker');
                        if (permissionKeyMap) {
                            module.category.forEach(item => {
                                let value = item.selected_value;
                                if (typeof value === 'string' && value) {
                                    value = value.split(',').map(v => v.trim());
                                }
                                const key = permissionKeyMap[item.id];
                                if (key) {
                                    permissionInfo[key] = value;
                                }
                            });
                        }
                    }
                    return permissionInfo;
                }
            }
        }
    }

    return permissionInfo;
};

export const isOwnerOnBoarding = (ownerOnboardingList, key, id, permissionList, permissionModule) => {
    let permissionInfo = {
        'worker_chat': '',
        'worker_contact_details': '',
        'worker_remarks': '',
        'worker_action_require_history': '',
        'worker_chat_history': '',
        'worker_status_to_hold': '',
        'worker_status_to_suspended': '',
        'worker_status_to_ban': '',
        'worker_employer_chat': '',
        'worker_jo_share': '',
        'worker_jo_share_link': '',
        'worker_interview_decline': '',
        'worker_interview_accept': '',
        'worker_interview_reschedule': '',
        'worker_interview_report': '',
        'worker_worker_profile': '',
        'worker_worker_biodata': '',
        'worker_worker_photo': "",
        'worker_philippines_worker_doc_upload': '',
        'worker_philippines_worker_assign_partner': '',
        'worker_indonesia_worker_doc_upload': '',
        'worker_indonesia_worker_assign_partner': '',
        'worker_indonesia_worker_assign_pt': '',
        'worker_worker_details': '',
        'worker_worker_basic_details': '',
        'worker_worker_consulate_details': '',
        'worker_worker_passport_details': '',
        'worker_worker_activity': '',
    };

    if (ownerOnboardingList && permissionList && ownerOnboardingList[key] && ownerOnboardingList[key].includes(Number(id))) {
        const module = permissionList.find(m => m.module === permissionModule);
        if (module) {
            if (module.category && Array.isArray(module.category)) {
                // Map of permissionInfo keys to category item ids
                const permissionKeyMap = getObejctByModule(permissionModule);
                if (permissionKeyMap) {
                    module.category.forEach(item => {
                        let value = item.selected_value;
                        if (typeof value === 'string' && value) {
                            value = value.split(',').map(v => v.trim());
                        }
                        const key = permissionKeyMap[item.id];
                        if (key) {
                            permissionInfo[key] = value;
                        }
                    });
                }
            }
        }
    }
    return permissionInfo;
};

const isAdminUser = () => {
    const currentUser = getStoredUser();
    return currentUser?.data?.role?.id === 1;
};

export const findPermission = (permissionModule, permissionId) => {
    if (!permissionModule || !permissionModule.category) return null;

    const per = permissionModule.category.find(item => item.id === permissionId) || null;
    return per;
};

export const hasPermission = (permissionList, moduleId, permissionId) => {
    if (isAdminUser()) return true;
    if (!permissionList || !Array.isArray(permissionList)) return false;

    const module = permissionList.find(m => m.module === moduleId);
    if (!module) return false;

    const permission = findPermission(module, permissionId);
    return permission?.selected_value === 'y';
};

export const getPermissionValue = (permissionList, moduleId, permissionId) => {
    if (isAdminUser()) return 'y';
    if (!permissionList || !Array.isArray(permissionList)) return false;

    const module = permissionList.find(m => m.module === moduleId);
    if (!module) return '';

    const permission = findPermission(module, permissionId);
    return permission?.selected_value;
};

export const getPermissionModule = (permissionList, moduleId) => {
    if (!permissionList || !Array.isArray(permissionList)) return false;

    const module = permissionList.find(m => m.module === moduleId);
    if (!module) return '';
    return module;
};

const getTimeDifference = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    let diff = end - start;
    if (diff < 0) {
        diff += 24 * 60 * 60 * 1000;
    }
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours} hr ${minutes} min`;
};

const isOwnerPermissionsOfContract = (ownerOnboardingList, contract_id) => {
    return ownerOnboardingList?.cs_of_contract_ids?.includes(contract_id) || false;
};

const isOwnerPermissionsOfJob = (ownerOnboardingList, empId) => {
    return ownerOnboardingList?.cs_of_employer_ids?.includes(empId) || false;
};

const getProcessingPermission = (permissionList, isOwner, permissionKey) => {
    const prefix = isOwner ? 'processing_cs_owner' : 'processing_cs_non_owner';
    return getPermissionValue(permissionList?.data, prefix, `${prefix}_${permissionKey}`) === 'y' || isAdminUser();
};

const customFromNow = (date) => {
    const now = dayjs();
    const targetDate = dayjs(date);
    const diffMinutes = now.diff(targetDate, 'minutes');

    // Handle "a few seconds ago" and similar dayjs.js phrases
    if (diffMinutes < 1) {
        const timeString = dayjs(date).fromNow();
        if (timeString.startsWith('a few') || timeString.startsWith('in a few seconds')) {
            return 'Few seconds ago';
        }
        return timeString
            .replace(/^a /, '1 ')
            .replace(/^an /, '1 ');
    }

    const diffHours = now.diff(targetDate, 'hours');
    const diffDays = now.diff(targetDate, 'days');
    const diffYears = now.diff(targetDate, 'years', true);

    if (diffMinutes < 60) {
        return `${ diffMinutes }min ago`;
    } else if (diffHours < 24) {
        const roundedHours = Math.round(diffHours);
        return `${ roundedHours }h ago`;
    } else if (diffDays < 30) {
        const roundedDays = Math.round(diffDays);
        return `${ roundedDays }d ago`;
    } else if (diffDays < 365) {
        const exactMonths = diffDays / 30;
        const roundedMonths = Math.round(exactMonths);
        return `${ roundedMonths }mo ago`;
    } else {
        const roundedYears = Math.round(diffYears);
        return `${ roundedYears }y ago`;
    }
};

const convertTo12HourFormat = (isoString) => {
    const date = new Date(isoString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return `${hours}:${formattedMinutes} ${ampm}`;
};

const getUserProfileDetails = (workerDetail) => [
    [
        { label: "key_age", value: workerDetail?.age },
        { label: "key_nationality", value: workerDetail?.nationality?.name },
    ],
    [
        { label: "key_height", value: workerDetail?.height?.name },
        { label: "key_chinese_horoscope", value: workerDetail?.chinese_horoscope?.name },
    ],
    [
        { label: "key_weight", value: `${workerDetail?.weight} ${workerDetail?.weight_measurement}` },
        { label: "key_horoscope", value: workerDetail?.horoscope?.name },
    ],
    [
        { label: "key_religion", value: workerDetail?.religion?.name },
        { label: "key_marital_status", value: workerDetail?.marital_status?.name },
    ],
];
const getFamilyDetails = (workerDetail) => [
    [
        {
            key: "key_number_of_children",
            label: "key_number_of_children",
            value: workerDetail?.children_count,
        },
        {
            key: "key_age_of_oldest_child",
            label: "key_age_of_oldest_child",
            value: workerDetail?.oldest_child_age,
        },
    ],
];

const getPartnerDetailTabStatus = (status) => {
    switch (status) {
        case 'in_review':
            return 'in_review';
        case 'verified':
            return 'ready';
        default:
            return 'not_ready';
    }
}

const formatFeedbackType = (type) => {
    switch (type) {
        case 'report_a_bug':
            return { label: 'Bug Reported', translationKey: 'key_bug_reporter' };
        case 'general_feedback':
            return { label: 'Feedback', translationKey: 'key_feedback' };
        case 'customer_service':
            return { label: 'Customer Service', translationKey: 'key_customer_service' };
        case 'employer':
            return { label: 'Employer', translationKey: 'key_employer' };
        case 'helper':
            return { label: 'Helper', translationKey: 'key_helper' };
        case 'other':
            return { label: 'Other', translationKey: 'key_other' };
        default:
            return { label: 'Other', translationKey: 'key_other' };
    }
}

const getExperienceDetails = (experience) => [
    [
        {
            label: "key_employer_nationality",
            value: experience?.employer_nationality_info?.name || "Not Provided",
        },
        {
            label: "key_size_of_home",
            value: experience?.house_size
                ? `${experience?.house_size} Sq Ft`
                : "Not Provided",
        },
    ],
    [
        {
            label: "key_district",
            value: experience?.district_info?.name || "Not Provided",
        },
        {
            label: "key_household_size",
            value: experience?.family_size || "Not Provided",
        },
    ],
    [
        {
            label: "key_language_spoken",
            value: experience?.spoken_language_info
                ? experience?.spoken_language_info.map((lang) => lang.name).join(", ")
                : "Not Provided",
        },
        {
            label: "key_reason_of_leaving",
            value: experience?.leaving_reason_info?.name || "Not Provided",
        },
    ],
];

const getDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/mobile/i.test(userAgent)) {
        return { name: "App", id: 2 };
    } else if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
        return { name: "Tab", id: 3 };
    } else {
        return { name: "Desktop", id: 1 };
    }
};

const getDownloadPdfKey = (formKey) => {
    const pdfKeyMapping = {
        'employer_id_988b': 'ID988B',
        'immigration_emp_doc': 'ID934A',
        'id_934a': 'ID934A',
        'key_id_988a': 'ID988A',
        'helper_id_988a': 'ID988A',
        'immigration_driver_duties_doc': 'ID678',
        'employer_id_407e': 'ID407E',
        'immigration_public_rental_doc': 'ID407G',
        'speed_up_letter': 'VISA_SPEED_UP_LETTER_TO_IMMIGRATION'
    };
    return pdfKeyMapping[formKey] || null;
}

const mapTableData = (processingDetails, groupMapping, groupName) => {
    return Object.keys(groupMapping).map((item) => ({
        label: item,
        eng: item,
        prepared: processingDetails[groupMapping[item] + "_prepared"] === 1,
        ready: processingDetails[groupMapping[item] + "_ready"] === 1,
        isDoc: !!processingDetails[groupMapping[item] + "_uploaded"],
        uploaded: processingDetails[groupMapping[item] + "_uploaded"] ? "Yes" : "No",
        selectedGroupName: groupName,
        isPdfLoading: false,
        key: getDownloadPdfKey(groupMapping[item]),
    }));
};

const getPermissionCategory = (permissionsData, permissionName) => {
    return permissionsData?.data?.find((module) => module.module === permissionName);
}

const getPageName = (workerObj) => {
    if (workerObj?.job_stage?.is_suggested && workerObj?.job_stage_status_id === 2) {
        return 'suggested';
    } else if (workerObj?.job_stage_status_id === 3) {
        return 'matched';
    } else if (workerObj?.job_stage_status_id === 4 ||
        workerObj?.job_stage_status_id === 5 ||
        workerObj?.job_stage_status_id === 6 ||
        workerObj?.job_stage_status_id === 10
    ) {
        return 'interview';
    } else if (!workerObj?.job_stage?.is_suggested && workerObj?.job_stage_status_id === 2) {
        return 'applied';
    } else if (workerObj?.job_stage_status_id === 1) {
        return 'invited';
    }
}

const getWorkerDeeplinkPageName = (workerObj) => {
    if (!workerObj) return '';

    const { job_stage_status, job_stage_is_suggested } = workerObj;

    if (job_stage_status === 20) {
        return 'profile';
    } else if ((job_stage_status === 2 && job_stage_is_suggested === 1) || job_stage_status === 17) {
        return 'suggested';
    } else if (job_stage_status === 2 && job_stage_is_suggested === 0) {
        return 'applied';
    } else if ([4, 5, 6, 10].includes(job_stage_status)) {
        return 'interview';
    } else if (job_stage_status === 3) {
        return 'matched';
    } else if (job_stage_status === 1) {
        return 'invited';
    } else {
        return '';
    }
};

const getInnerPermissionCategory = (permissionsData, moduleName, id) => {
    const employerModule = getPermissionCategory(permissionsData, moduleName);
    if (!employerModule) return null;

    // Check direct
    const mainCategory = employerModule.category.find(cat => cat.id === id);
    if (mainCategory) return mainCategory;

    // Check in child array
    for (const category of employerModule.category) {
        if (category.child) {
            const childCategory = category.child.find(child => child.id === id);
            if (childCategory) return childCategory;
        }
    }

    return null;
};

const getSavedLanguage = () => {
    const savedLanguage = localStorage.getItem('i18nextLng');
    return savedLanguage || 'en';
}

const getPdfFileName = (row, contractDetails) => {
    return `${ row?.service_agreement || row?.key || row?.pdfFileName || 'document' }-${ contractDetails?.id }-${ contractDetails?.worker_name }-${ contractDetails?.employer_name }.pdf`;
}

const copyToClipboard = async (text) => {
    const input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999); // For mobile compatibility

    try {
        document.execCommand('copy');
        ShowToast('success', 'Copied to clipboard');
    } catch (copyErr) {
        console.error('Failed to copy text: ', copyErr);
    }
    document.body.removeChild(input);
};

const nullifyIfStringNull = (value) => value === 'null' ? null : value;

const validateFamilyDetailsTabStatus = (familyDetails) => {
    if (familyDetails && familyDetails.length > 0) {
        return true;
    }
    return false;
}

const validateBasicDetailsTabStatus = (currentEmployer) => {
    if (
        currentEmployer?.title &&
        currentEmployer?.name &&
        currentEmployer?.gender !== null &&
        currentEmployer?.primary_residential_address?.address_line_1 &&
        currentEmployer?.location_info?.name &&
        currentEmployer?.spoken_language_info?.name
    ) {
        return true;
    }
    return false;
}

const getFilesNeedingConversion = (files) => {
    return Array.from(files).filter(file =>
        file.type !== "application/pdf" &&
        ['image/jpeg', 'image/png', 'image/jpg', 'application/doc', 'application/docx'].includes(file.type)
    );
};

const deepLinkAPIHeader = () => {
    return {
        'x-api-key': REACT_APP_X_API_KEY,
        'hosttype': HOST_TYPE,
        'device': navigator.userAgent,
        'ip': localStorage.getItem('userIP'),
        'Content-Type': 'application/json',
        'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
    }
}

const isOverseasIndoOrFilipino = (worker) => {
    if (!worker) return false;

    const { nationality_id, type } = worker;
    return (nationality_id === indonesiaId || nationality_id === fillipinoId) && (type === 2 || type === 'Overseas');
}

const formatTimeTo12HourFormat = (timeString) => {
    if (!timeString) return '-';
    return dayjs(timeString, 'HH:mm:ss').format('hh:mm A');
};

export {
    getAccessToken,
    convertToYesNo,
    convertToNumeric,
    formatDateTime,
    getCurrentDate,
    formatDate,
    formatTime,
    extractIds,
    convertToDayType,
    leaveDisplayStatus,
    getLeaveButtonClass,
    calculateDuration,
    getLocalTimeZone,
    useQuery,
    doopDays,
    getCurrentUser,
    isAdminUser,
    shortenText,
    uploadFile,
    uploadChatFile,
    getTimeRequestStatusLabel,
    ledgerDisplayType,
    arrayToObjectCovert,
    getContractInvoiceStatusLabel,
    invoicesStatusFilterOptions,
    mapFamilyDetails,
    mapFamilyDetailsInfo,
    getDisplayAgencyType,
    getDisplayAgencyCategory,
    downloadExcelFromBufferData,
    generateFilename,
    downloadFile,
    timeSince,
    getDisplayName,
    checkPermission,
    getTimeDifference,
    convertTo12HourFormat,
    customFromNow,
    getUserProfileDetails,
    getFamilyDetails,
    getExperienceDetails,
    getDeviceType,
    getCalculatedAge,
    relationMap,
    showSuccessOrError,
    showErrorMessage,
    dayMapping,
    uploadFiles,
    mapTableData,
    validateBasicDetailsTabStatus,
    validateFamilyDetailsTabStatus,
    copyToClipboard,
    nullifyIfStringNull,
    getFilesNeedingConversion,
    getPermissionCategory,
    getInnerPermissionCategory,
    isDisabledCsOption,
    getPredefinedRangeFromDates,
    isOwnerPermissionsOfContract,
    isOwnerPermissionsOfJob,
    getProcessingPermission,
    isBangladeshOrThailandPartner,
    deepLinkAPIHeader,
    getPageName,
    getWorkerDeeplinkPageName,
    getPdfFileName,
    getPartnerDetailTabStatus,
    isOverseasIndoOrFilipino,
    getSavedLanguage,
    formatDuration,
    formatFeedbackType,
    formatTimeTo12HourFormat
};
